import React from 'react';

export function getPasswordRequirements() {
    return (
        <div>
            Your password must contain the following:
            <ul>
                <li>At least 8 characters</li>
                <li>At least 1 uppercase letter and 1 lowercase letter</li>
                <li>At least 1 number</li>
                <li>At least 1 symbol</li>
            </ul>
        </div>
    );
}
